var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConsole(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57 57",
    style: {
      enableBackground: "new 0 0 57 57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M55.781,51.749H1.219C0.546,51.749,0,51.203,0,50.53V30.968c0-0.673,0.546-1.219,1.219-1.219h54.562 c0.673,0,1.219,0.546,1.219,1.219V50.53C57,51.203,56.454,51.749,55.781,51.749z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#283238"
    },
    points: "57,34.749 57,32.749 28,32.749 28,29.749 26,29.749 26,32.749 0,32.749 0,34.749 26,34.749  26,46.749 0,46.749 0,48.749 26,48.749 26,51.749 28,51.749 28,48.749 57,48.749 57,46.749 28,46.749 28,34.749 "
  }), /*#__PURE__*/React.createElement("rect", {
    y: 39.749,
    style: {
      fill: "#839594"
    },
    width: 19,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 39.749,
    style: {
      fill: "#839594"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#E7ECED",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 49,
    cy: 40.749,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#38454F"
    },
    d: "M28.144,21.104h5.473c0.986,0,1.939,0.353,2.687,0.994l5.288,4.533 c0.354,0.303,0.872,0.355,1.266,0.106c5.502-3.482-1.172-16.732-2.494-19.227c-0.14-0.265-0.371-0.462-0.653-0.564L35.264,5.33 c-0.39-0.142-0.824-0.09-1.169,0.14l-0.593,0.395c-0.234,0.156-0.508,0.239-0.789,0.239h-4.569h-4.569 c-0.281,0-0.555-0.083-0.789-0.239L22.193,5.47c-0.345-0.23-0.779-0.282-1.169-0.14l-4.447,1.617 c-0.281,0.102-0.512,0.299-0.653,0.564c-1.323,2.495-7.996,15.745-2.494,19.227c0.394,0.249,0.912,0.197,1.266-0.106l5.288-4.533 c0.748-0.641,1.701-0.994,2.687-0.994H28.144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#283238"
    },
    d: "M56.068,29.359l-8.85-8.151c-0.074-0.059-0.166-0.092-0.262-0.092h-1.983 c0.148,2.421-0.368,4.515-2.116,5.621c-0.394,0.249-0.912,0.197-1.266-0.106l-5.288-4.533c-0.715-0.613-1.619-0.953-2.558-0.982 H22.542c-0.939,0.03-1.843,0.369-2.558,0.982l-5.288,4.533c-0.354,0.303-0.872,0.355-1.266,0.106 c-1.748-1.107-2.264-3.201-2.116-5.621H10.25c-0.095,0-0.187,0.032-0.262,0.092l-9.056,8.151c-0.309,0.247-0.134,0.746,0.262,0.746 h54.613C56.202,30.104,56.377,29.606,56.068,29.359z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#283238"
    },
    cx: 34.5,
    cy: 17.249,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#283238"
    },
    cx: 19.5,
    cy: 11.249,
    r: 2.5
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#283238"
    },
    points: "27,15.749 25,15.749 25,13.749 23,13.749 23,15.749 21,15.749 21,17.749 23,17.749  23,19.749 25,19.749 25,17.749 27,17.749 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 9.749,
    style: {
      fill: "#7383BF"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 9.749,
    style: {
      fill: "#D75A4A"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 11.749,
    style: {
      fill: "#61B872"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 7.749,
    style: {
      fill: "#EBBA16"
    },
    width: 2,
    height: 2
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsole);
export default __webpack_public_path__ + "static/media/console.b200dfc626fde9b88327d944fd4c88d0.svg";
export { ForwardRef as ReactComponent };